import { getBuildTypesFlags } from 'src/context/site-context-helper';
import type { Styling } from 'src/context/styling';
import type { BuildType } from 'src/enums/build/build-type';
import { colors, flex, globalBannerHeight, mainNavHeight, zIndexes } from 'src/styling/constants';
import mq from 'src/styling/media-queries';

export const createMobileNavStyle = (
  styling: Styling,
  buildType: BuildType,
  bannerIsActive: boolean
) => {
  const { isDL } = getBuildTypesFlags(buildType);
  return {
    wrapperStyling: mq({
      zIndex: zIndexes.mobileNav,
      top: bannerIsActive ? `calc(${globalBannerHeight.mobile} + ${mainNavHeight})` : mainNavHeight,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: styling.colors.headerBackground,
      position: 'fixed',
      overflow: 'auto',
      display: ['flex', 'none'],
      flexDirection: 'column',
      alignItems: 'center',
    }),
    linksWrapperStyling: mq([
      flex.columnCentered,
      {
        width: '100%',
        overflowY: 'auto',
        color: isDL ? styling.colors.capeCod : styling.colors.highlightText,
        flexWrap: 'nowrap',
      },
    ]),
    secondaryLinksWrapperStyling: mq([
      {
        width: '100%',
        color: isDL ? styling.colors.capeCod : styling.colors.highlightText,
        textDecoration: 'underline',
        lineHeight: '2.5',
      },
    ]),
    staticTextWrapperStyling: mq([
      flex.columnCentered,
      styling.fonts.bold,
      {
        flex: '1 1 auto',
        justifyContent: 'center',
        fontSize: isDL ? '1.1875rem' : '3vh',
        lineHeight: 1.5,
      },
    ]),
    navigationPageStyling: mq([
      flex.columnCentered,
      isDL ? styling.fonts.regular : styling.fonts.bold,
      { fontSize: isDL ? '1.1875rem' : '2vh', textAlign: 'center' },
    ]),
  };
};

export const createMobileNavClubStyle = (styling: Styling, buildType: BuildType) => {
  const { isDL } = getBuildTypesFlags(buildType);
  return {
    clubWrapperStyle: mq([
      flex.row,
      {
        flexShrink: 0,
        border: `1px solid ${colors.lightGray}`,
        color: styling.colors.highlightText,
        margin: '1rem 0',
        fontSize: '1rem',
        padding: '1rem',
      },
    ]),
    clubNameStyle: mq([
      styling.fonts.bold,
      {
        flex: 1,
        color: styling.colors.headerClubName,
        fontSize: '1.2rem',
      },
    ]),
    headerWrapperStyle: mq([
      styling.fonts.regular,
      styling.common.link,
      isDL ? { color: styling.colors.capeCod } : {},
    ]),
  };
};
